<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useUserStore } from '../../stores/userStore'
import { useCartStore } from '../../stores/cartStore'
import { useGlobalStore } from '../../stores/globalStore'

const props = defineProps({
  teamSlug: String
})

const userStore = useUserStore()
const cartStore = useCartStore()
const globalStore = useGlobalStore()

const businessList = ref([])

const otherBusinessesCount = computed(() => {
  return businessList.value.length - 1
})

const showAlert = computed(() => {
  return (
    globalStore.shouldShowAlert('other-businesses') &&
    otherBusinessesCount.value > 1
  )
})

const businessText = computed(() => {
  return otherBusinessesCount.value === 1 ? 'business' : 'businesses'
})

async function loadBusinesses() {
  try {
    // First ensure we have user data
    let initialized = false
    if (!userStore.isInitialized) {
      initialized = await userStore.init()
    } else {
      initialized = await userStore.fetchUserDetails()
    }

    // If initialization failed or we don't have user data, retry once
    if (!initialized || !userStore.user) {
      console.warn('Retrying user data fetch...')
      await new Promise((resolve) => setTimeout(resolve, 1000)) // Wait 1 second
      initialized = await userStore.init()
    }

    if (!initialized || !userStore.user) {
      console.error('User data is not available after initialization')
      businessList.value = []
      return
    }

    const uuid = userStore.user.uuidFromEmail
    if (!uuid) {
      console.error('uuidFromEmail is missing from user data')
      businessList.value = []
      return
    }

    const response = await cartStore.searchForCompany('', uuid, 'boi-report')

    if (!response || !Array.isArray(response.companies)) {
      console.error('Invalid response from searchForCompany:', response)
      businessList.value = []
      return
    }

    businessList.value = response.companies
  } catch (error) {
    console.error('Error loading businesses:', error)
    businessList.value = []
  }
}

function dismissAlert() {
  globalStore.dismissAlert('other-businesses')
}

onMounted(() => loadBusinesses())
</script>

<template>
  <div v-if="showAlert" class="card card-sm mb-3">
    <div class="card-body">
      <span class="text-primary me-2"
        ><i class="fa-duotone fa-solid fa-sparkles"></i
      ></span>
      It looks like you may have
      <strong>{{ otherBusinessesCount }} other {{ businessText }}.</strong>
      <a class="card-link ms-2" href="/cart/c/florida-annual-report/"
        >Add them here<span
          class="fa fa-solid fa-chevrons-right small ms-1"
        ></span
      ></a>
      <button
        @click="dismissAlert"
        class="btn-close position-absolute top-0 end-0 m-2 p-2"
        aria-label="Close"
      ></button>
    </div>
  </div>
</template>
